import { X_CURRENCY_HEADER } from '@/config/currency';
import { getRequestCurrency } from '@/lib/currency/getRequestCurrency';

/**
 * Thin fetch wrapper for backend API calls.
 * Attaches X-Currency from the persisted customer currency cookie.
 * Does not replace auth headers or invent a second HTTP client stack.
 */
export async function apiFetch(input: RequestInfo | URL, init?: RequestInit): Promise<Response> {
  const currency = await getRequestCurrency();
  const headers = new Headers(init?.headers);

  if (!headers.has(X_CURRENCY_HEADER)) {
    headers.set(X_CURRENCY_HEADER, currency);
  }

  return fetch(input, {
    ...init,
    headers,
  });
}
